import { Box, Grid, Typography } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { BLUE_COLOR } from '../../../../constants/ColorsConst';
import { useNotification } from '../../../../helpers/Notification';
import { LoadingWidget } from '../../../../widgets';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';
import { allNivelesAcademicosAction } from '../../../sistema/niveles_academicos/NivelesAcademicosAction';
import CardNivelesAcademicosComponent from '../../../sistema/niveles_academicos/components/CardNivelesAcademicos';
import { tiposNivelAcademicoArray } from '../../../sistema/niveles_academicos/components/ListadoNivelesAcademicos';
import { saveEntNivelesAcademicosAction } from '../EntNivelesAcademicosAction';

const FormEntNivelesAcademicos = () => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const entNivelesAcademicosStore = Redux.useSelector(
    (state) => state.entNivelesAcademicos,
  );
  const nivelesAcademicosStore = Redux.useSelector(
    (state) => state.nivelesAcademicos,
  );

  const [datas, setDatas] = React.useState([]);
  const [select, setSelect] = React.useState(null);

  React.useEffect(() => {
    async function fetchData() {
      if (
        nivelesAcademicosStore.all &&
        nivelesAcademicosStore.all.length === 0
      ) {
        await allNivelesAcademicosAction(dispatch, null);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (nivelesAcademicosStore.all.length > 0) {
      let niveles = [];
      let ids = [];
      entNivelesAcademicosStore.all.forEach((el) => {
        ids.push(el.nivelAcademico.id);
      });

      nivelesAcademicosStore.all.forEach((nivel) => {
        if (!ids.includes(nivel.id)) {
          niveles.push(nivel);
        }
      });

      let res = [];
      tiposNivelAcademicoArray.forEach((el) => {
        res.push({
          tipo: el,
          data: niveles
            .filter((e) => e.tipoNivelAcademico === el)
            .sort((a, b) => parseInt(a.numero) - parseInt(b.numero)),
        });
      });

      setDatas(res);
    }
  }, [nivelesAcademicosStore.all, entNivelesAcademicosStore.all]);

  const [loadingSave, setLoadingSave] = React.useState(false);

  return (
    <Box component="form">
      <Grid container spacing={2}>
        {loadingSave && (
          <Grid item xs={12} md={12}>
            <LoadingWidget isLoading={loadingSave} />
          </Grid>
        )}
        {datas.map((tipo) => {
          return (
            <Grid item xs={12} md={4} key={tipo.tipo}>
              <Typography fontSize="14pt" fontWeight="bold" color={BLUE_COLOR}>
                {tipo.tipo}
              </Typography>
              {tipo.data.map((el) => {
                return (
                  <CardNivelesAcademicosComponent
                    data={el}
                    activo={select?.id === el.id}
                    onClick={async () => {
                      setSelect(el);
                    }}
                  />
                );
              })}
            </Grid>
          );
        })}
      </Grid>
      {select && (
        <DeleteModalComponent
          open={select}
          onClose={() => setSelect(null)}
          title="Asignar"
          onDelete={async () => {
            setLoadingSave(true);
            const data = {
              idEntidad: entidadesStore.activo.id,
              idNivelAcademico: select.id,
              idEstatus: 1,
            };
            await saveEntNivelesAcademicosAction(
              { dispatch, notify },
              null,
              data,
              entNivelesAcademicosStore.params,
            );
            setSelect(null);
            setLoadingSave(false);
          }}
          text="¿Está seguro que desea asignar el nivel académico?"
          isDelete={false}
        >
          <Typography variant="h6" fontWeight="bold">
            {select?.nombre}
          </Typography>
          <Typography variant="body1">{select?.tipoNivelAcademico}</Typography>
        </DeleteModalComponent>
      )}
    </Box>
  );
};

export default FormEntNivelesAcademicos;
